export default __webpack_public_path__ + "static/media/conekta.5739e09e.svg";